const isProduction = location.host.indexOf("ddxq.mobi") > -1; // 通过域名判断
import { config } from "./package.json";

let env = "";
// 如果不是生产，说明是线上测试、本地开发环境
if (!isProduction) {
  if (process.env.NODE_ENV == "development") {
    env = config.env || "t";
  } else {
    env = "t";
  }
  // 在链接里添加参数表示环境,envt envr
  if (location.href.indexOf("envr") > -1) {
    env = "r";
  }
}

export { env, isProduction };
